var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgL12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1786 0H1.82143C1.33836 0 0.875068 0.1919 0.533484 0.533484C0.1919 0.875068 0 1.33836 0 1.82143L0 15.1786C0 15.6616 0.1919 16.1249 0.533484 16.4665C0.875068 16.8081 1.33836 17 1.82143 17H7.02958V11.2204H4.63895V8.5H7.02958V6.42661C7.02958 4.06824 8.43359 2.76554 10.584 2.76554C11.6139 2.76554 12.6908 2.9492 12.6908 2.9492V5.26393H11.5042C10.3351 5.26393 9.97042 5.98946 9.97042 6.73359V8.5H12.5804L12.163 11.2204H9.97042V17H15.1786C15.6616 17 16.1249 16.8081 16.4665 16.4665C16.8081 16.1249 17 15.6616 17 15.1786V1.82143C17 1.33836 16.8081 0.875068 16.4665 0.533484C16.1249 0.1919 15.6616 0 15.1786 0Z",
    fill: "#846230"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL12);
export default __webpack_public_path__ + "static/media/L1 (2).03aa0a86f3470ef08e4bf753cbce7e28.svg";
export { ForwardRef as ReactComponent };